"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TournamentAccessibility = void 0;
var TournamentAccessibility;
(function (TournamentAccessibility) {
    /**
     * Anybody can join to match
     */
    TournamentAccessibility["Public"] = "public";
    /**
     * Only invited user can join to match
     */
    TournamentAccessibility["Private"] = "private";
})(TournamentAccessibility = exports.TournamentAccessibility || (exports.TournamentAccessibility = {}));
//# sourceMappingURL=tournament-accessibility.js.map